// extracted by mini-css-extract-plugin
export default {"localeSelector":"DestinationEditorPage_localeSelector__LVjEA"};